import React from 'react';
import { motion } from 'framer-motion';
export function CTABand() {
  return <section className="px-6 pb-24 bg-brand-black" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-7xl mx-auto bg-brand-green clip-cta-band py-10 md:py-16 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-109">
        <div className="text-center md:text-left" data-id="element-110">
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bebas text-brand-black mb-2" data-id="element-111">
            READY TO BE PEST-FREE?
          </h2>
          <p className="font-barlow text-base md:text-xl text-brand-black/80 font-medium" data-id="element-112">
            Get your free inspection today.
          </p>
        </div>

        <button onClick={() => document.getElementById('contact')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })} className="bg-brand-black text-white font-bold px-8 md:px-10 py-4 md:py-5 clip-parallelogram hover:bg-white hover:text-black transition-colors font-condensed uppercase tracking-widest text-lg md:text-xl whitespace-nowrap shadow-xl" data-id="element-113">
          Call Us Now
        </button>
      </motion.div>
    </section>;
}